angular
  .module("totalGroupCustomer.components", [])
  .component("totalGroupCustomer", {
    templateUrl: "ng/components/riskCourse/totalGroupCustomer/totalGroupCustomer.view.html",
    bindings: {
      model: "=",
      totalPractices: "<",
      totalPracticesImport: "<",
      downloadKey: '<'
    },
    controllerAs: "totalGroupCustomerCtrl",
    controller: function TotalGroupCustomer($download) {
      var self = this;

      self.$onInit = function () {
        console.log("model totalGroupCustomer", self.model);
      };

      self.stampaPdf = function () {
        console.log("preventivo anno", self.model.preventivo.anno);
        console.log("preventivo numero", self.model.preventivo.numero);

        var input = {
          downloadKey: self.downloadKey
        }
        var url = "/uni/getFileRic/service-infos/";
        $download.getGenericDownload(url, input)
          .then(function (response) {
            console.log(response)
          })

      };
    },
  });